export default {

	/**
	 * Custom Translation Utility
	 *
	 * @example t('namespace.item.subitem') => window.app.translations.namespace.item.subitem
	 *
	 * @param {string} key Path of the target translation item
	 * @returns {string|object} Translation
	 */
	t: (key) => {
		const path = key.split('.');

		try {
			const result = path.reduce(
				(previous, key) => previous[key],
				window.app.translations
			);

			if (!result) {
				throw new Error();
			}

			return result;
		} catch {
			console.error(`No translation available for key ${key}`);
			return '';
		}
	}

};
